import { useTranslation } from 'react-i18next';
import { ServicesAdditionalData } from '../../utils/types';
import { ImgsLuggage, SERVICE_INDEX } from '../../utils/utils';
import { useScrollToTop } from '../../utils/hook';
import {
  ContentCardServices,
  Separator,
  TitleContainer,
} from '../CommonComponents';

const LuggagePage = () => {
  const { t } = useTranslation();
  useScrollToTop();

  const LUGGAGE_SERVICE_ADDITIONAL_DATA = t(
    'services.' + SERVICE_INDEX.LUGGAGE + '.additionalData',
    {
      returnObjects: true,
    }
  ) as ServicesAdditionalData[];

  return (
    <>
      <Separator />
      <TitleContainer serviceIndex={SERVICE_INDEX.LUGGAGE} />{' '}
      <ContentCardServices
        imgs={ImgsLuggage}
        additionalData={LUGGAGE_SERVICE_ADDITIONAL_DATA}
      />
    </>
  );
};

export default LuggagePage;
